var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1004,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.998 39.691C368.184 61.456 444.461 105.458 502 146.773c57.539-41.315 133.816-85.317 208.002-107.082 119.295-35 198.498-29.501 291.998-4V223H2V35.691c93.5-25.501 172.703-31 291.998 4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 49.533C188.264 1.55 350.101 57.531 487 151",
    stroke: "#FE9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M517 144C367.154 25.476 190.714-31.99 2 25.475",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 49.533C815.736 1.55 653.899 57.531 517 151",
    stroke: "#FE9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M487 144C636.846 25.476 813.286-31.99 1002 25.475",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#mobile-animation_svg__filter0_f_2046_14613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477 216l7.979-68h33.51L527 216l-25-19.361L477 216z",
    fill: "#010E23"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M481 155.932h42v34h-42z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480 130.481L502 144l22.835-14.587V213l-22.42-22.225L480 213v-82.519zm27.648 44.136l11.562-2.436-2.734-8.174-11.082 4.527 1.364-11.489h-8.681l.866 11.69-10.701-4.596-2.611 8.042 11.568 2.683-7.716 8.518 6.972 5.027 6.088-10.133 6.089 10.133 6.843-5.027-7.827-8.765z",
    fill: "#222F64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mobile-animation_svg__filter0_f_2046_14613",
    x: 473,
    y: 144,
    width: 58,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2046_14613"
  })))));
}

export default "data:image/svg+xml;base64,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";
export { SvgMobileAnimation as ReactComponent };